import ActivityGraph from './container/ActivityGraphContainer'

export default ActivityGraph
